import {TrackingProductStreamSortType} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {
  DataLayerQuickFilterEvent,
  DataLayerQuickFilterEventGA4,
} from './trackFilterSelection';

export const trackProductListSort =
  ({sort}: {sort: TrackingProductStreamSortType}) =>
  (clientState: TrackingClientStateHolder): DataLayerQuickFilterEvent => {
    clientState.update({sort});
    const {currentPage} = clientState.getCurrent();

    const eventGA4: DataLayerQuickFilterEventGA4 = {
      event: 'filter',
      action: 'submit',
      label: 'filter_modal',
      value: null,
      content_name: currentPage?.page?.path || '',
      page_type: currentPage?.page?.type || '',
      page_type_id:
        currentPage?.type === 'detailed' ? `${currentPage.page?.id || ''}` : '',
      attribute_group: 'sort',
      attributes: sort,
    };
    return {
      GA4: eventGA4,
    };
  };
